// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VuePaginate from 'vue-paginate'
import VueTheMask from 'vue-the-mask'
import Vue2TouchEvents from 'vue2-touch-events'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import {appHeader, appLoader} from './components'
import {Auth} from '@/services';
import store from './services/store';

import '@/assets/styles.scss'
import '../node_modules/bootstrap/scss/bootstrap.scss'

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import I18NextVue from 'i18next-vue';

import moment from 'moment';
import 'moment/locale/es';
// import 'moment/locale/en';
import 'moment/locale/pt';

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV == 'development';

i18next
.use(HttpApi)
.use(LanguageDetector)
.init({
	"backend": {
		loadPath: '/static/i18n/{{lng}}.json'
	}
});

Vue.use(Vuex);
Vue.use(VuePaginate);
Vue.use(VueTheMask);
Vue.use(Vue2TouchEvents);
Vue.use(Viewer);
Vue.use(I18NextVue, {i18next});

Vue.prototype.moment = moment;
Vue.prototype.i18next = i18next;


Vue.component('app-header', appHeader);
Vue.component('app-loader', appLoader);

Auth.init().then(() => {
	new Vue({
		el: '#app',
			router,
			store,
		components: { App },
			template: '<App/>',
			data: {
				app: {
					busy: false
				}
			},
			beforeCreated() {;
				this.app.busy = true;
			},
			ready() {
				this.app.busy = false
			}
	})
	console.log("Setting locale settings to: " + i18next.language);
	moment.locale(i18next.language);
});


// WEBPACK FOOTER //
// ./src/main.js